<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card
        :loading="loading"
        flat
        min-height="300"
        style="overscroll-behavior: contain"
      >
        <custom-tabs
          v-model="tabs"
          :tabItems="translatedTabItems"
          :tabProps="{ color: 'primary' }"
          :tabsItemsAttrs="{ color: 'primary' }"
          show-arrows
          grow
        >
          <template v-slot:tab="{ tab }">
            <v-icon right>{{ tab.icon }}</v-icon>
            <span class="font-weight-bold">{{ tab.text }}</span>
            <help-info
              :element-name="`${serviceName}-${componentName}-tab-${tab.value}`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="tab.text"
            />
          </template>
          <template v-slot:staticItems>
            <v-tab-item>
              <v-row
                v-if="!!defaultVideos"
                class="pa-3 custom-scrollbar"
                no-gutters
                style="max-height: calc(90vh - 250px); overflow-y: auto"
              >
                <v-col class="pb-2" cols="12">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="search.defaults"
                      :loading="loading"
                      append-icon="mdi-magnify"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      hide-details
                      :label="$t('search')"
                      outlined
                      @click:append="handleSearch(true)"
                      @keydown.enter="handleSearch(true)"
                      @click:clear="clearSearch(false)"
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-search-Video`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('search')"
                    />
                  </div>
                </v-col>

                <template v-for="defVideo in defaultVideos.data">
                  <v-col
                    :key="defVideo.id"
                    :class="
                      value.images.findIndex(
                        (item) => item.id === defVideo.id
                      ) > -1
                        ? 'border border-2 border-success'
                        : 'border'
                    "
                    :data-img="defVideo.id"
                    class="pa-1"
                    cols="12"
                    md="4"
                    @click="select(defVideo)"
                  >
                    <video-selector-card
                      :value="
                        value.images.findIndex(
                          (item) => item.id === defVideo.id
                        ) > -1
                      "
                      :video="defVideo"
                    />
                  </v-col>
                </template>

                <v-col cols="12">
                  <v-card
                    v-if="!loading && !defIsLastPage && tabs === 0"
                    v-intersect="onDefaultIntersect"
                    flat
                  >
                    <v-progress-circular
                      color="primary"
                      indeterminate
                      size="35"
                      width="5"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item>
              <v-row
                class="pa-3 custom-scrollbar"
                no-gutters
                style="max-height: calc(90vh - 300px); overflow-y: auto"
              >
                <v-col class="pb-2" cols="12">
                  <div class="rowinfo" style="width: 100%">
                    <v-text-field
                      v-model="search.user"
                      :loading="loading"
                      append-icon="mdi-magnify"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      class="contentinfo"
                      dense
                      hide-details
                      :label="$t('search')"
                      outlined
                      @click:append="handleSearch(false)"
                      @keydown.enter="handleSearch(false)"
                      @click:clear="clearSearch(true)"
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-search-user`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('search')"
                    />
                  </div>
                </v-col>

                <v-col
                  v-for="(video, j) in userVideos.data"
                  :key="video.id"
                  :class="
                    value.images.findIndex((item) => item.id === video.id) > -1
                      ? 'border border-2 border-success'
                      : ''
                  "
                  :data-img="video.id"
                  class="pa-1"
                  cols="12"
                  md="4"
                  @click="select(video)"
                >
                  <video-selector-card
                    :value="
                      value.images.findIndex((item) => item.id === video.id) >
                      -1
                    "
                    :video="video"
                    show-delete
                    @delete="deleteVideo($event)"
                  />
                </v-col>

                <v-col cols="12">
                  <v-card
                    v-if="!loading && !isLastPage && tabs === 1"
                    v-intersect="onIntersect"
                  >
                    <v-progress-circular
                      color="primary"
                      indeterminate
                      size="35"
                      width="5"
                    />
                  </v-card>
                </v-col>
              </v-row>

              <v-card
                v-if="!loading && (!userVideos.data || !userVideos.data.length)"
                flat
                style="max-height: calc(90vh - 250px); overflow-y: auto"
                width="100%"
              >
                <v-card-title
                  class="text-center justify-center"
                  v-text="$t('no_videos_found')"
                />
                <v-card-subtitle class="text-center">
                  {{ $t("upload_video_prompt") }}
                </v-card-subtitle>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <video-by-link
                :images.sync="computedValue.images"
                @fetch="reloadByUpload"
                @close="$emit('close')" 

              />
            </v-tab-item>

            <v-tab-item>
              <video-upload-handler @fetch="reloadByUpload" />
            </v-tab-item>
          </template>
        </custom-tabs>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import VideoSelectorCard from "@/view/components/UploadCenter/videoUploader/videoSelectorCard";
import VideoByLink from "@/view/components/UploadCenter/videoUploader/videoByLink";
import VideoUploadHandler from "@/view/components/UploadCenter/videoUploader/videoUploadHandler";

export default {
  name: "videoUploader",

  components: { VideoUploadHandler, VideoByLink, VideoSelectorCard },

  props: {
    singleGallery: Boolean,
    value: [Array, String, Object],
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "videoUploader",

      defaultVideos: {
        data: [],
      },
      defIsLastPage: false,
      defPage: 1,
      errors: "",
      filesModel: null,
      getError: false,
      isIntersecting: false,
      isLastPage: false,
      loading: false,
      page: 1,
      search: {
        defaults: "",
        user: "",
      },
      tabs: 0,
      upLoading: false,
      userVideos: {
        data: [],
      },
    };
  },

  mounted() {
    this.getDefaultVideos();
  },

  computed: {
    tabItems() {
      return [
        {
          text: this.$t("tabs.ready_video"),
          icon: "mdi-broadcast",
          value: "ready_video",
          id: 0,
        },
        {
          text: this.$t("tabs.video_gallery"),
          icon: "mdi-image-area-close",
          value: "video_gallery",
          id: 1,
        },
        {
          text: this.$t("tabs.link"),
          icon: "mdi-link-plus",
          value: "link",
          id: 2,
        },
        {
          text: this.$t("tabs.video_upload"),
          icon: "mdi-cloud-upload-outline",
          value: "video_upload",
          id: 3,
        },
      ];
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    translatedTabItems() {
      return this.tabItems.map((item) => ({
        ...item,
        text: this.$t(`tabs.${item.value}`),
      }));
    },
  },

  methods: {
    fetch() {
      this.page = 1;
      this.tabs = 1;
      this.$nextTick(() => {
        this.getUserVideos();
      });
    },
    getDefaultVideos(s) {
      this.loading = true;

      let params = {
        default: 1,
        page: this.defPage,
      };

      if (!!s) params.search = s;

      this.$nextTick(() => {
        this.$api
          .get("/user/aparat", {
            params: params,
          })
          .then(({ data }) => {
            let lastImg = this.defaultVideos?.data || [];
            let temp = data.data;
            temp.data = lastImg.concat(temp.data);
            this.defaultVideos = temp;

            this.defIsLastPage = !data.data.next_page_url;
            this.defPage++;
          })
          .catch(({ response }) =>
            console.log("error in get default aparat videos: ", response)
          )
          .finally(() => (this.loading = false));
      });
    },
    getUserVideos(s) {
      this.loading = true;

      let params = {
        page: this.page,
        dir: "desc",
      };

      if (!!s) params.search = s;

      this.$api
        .get("/user/aparat", {
          params: params,
        })
        .then(({ data }) => {
          let lastImg = this.userVideos?.data || [];
          let temp = data.data;
          temp.data = lastImg.concat(temp.data);
          this.userVideos = temp;

          this.isLastPage = !data.data.next_page_url;
          this.page++;
        })
        .catch(({ response }) =>
          console.log("error in get user aparat videos: ", response)
        )
        .finally(() => (this.loading = false));
    },
    select(image) {
  const index = this.value.images.findIndex((item) => item.id === image.id);

  if (index === -1) {
    if (this.onePic) {
      this.computedValue.images = [{
        name: image.title,
        title: image.title,
        file_link: image.full_path || image.file_link || image.url, 
        description: image.description || "",
        link: "",
        id: image.id,
      }];
      if (this.onePic) this.$emit("update:field", image.full_path || image.file_link);
    } else {
      this.computedValue.images.push({
        name: image.title,
        title: image.title,
        file_link: image.full_path || image.file_link || image.url,
        description: image.description || "",
        link: "",
        id: image.id,
      });
    }
  } else {
    this.deleteSelectedImage(image);
  }
},
    deleteSelectedImage(image) {
      let index = this.computedValue.images.findIndex((item) =>
        !!item.id ? item.id === image.id : item.url === image.url
      );
      this.computedValue.images.splice(index, 1);
    },
    onDefaultIntersect(entries, observer) {
      this.isIntersecting = entries[0].isIntersecting;
      this.$nextTick(() => {
        if (
          (this.isIntersecting || !this.defaultVideos.data) &&
          !this.defIsLastPage
        ) {
          this.getDefaultVideos();
        }
      });
    },
    onIntersect(entries, observer) {
      this.isIntersecting = entries[0].isIntersecting;
      this.$nextTick(() => {
        if ((this.isIntersecting || !this.userVideos.data) && !this.isLastPage)
          this.getUserVideos();
      });
    },
    deleteVideo(id) {
      this.loading = true;

      this.$api
        .delete(`/user/aparat/${id}`)
        .then(({ data }) => {
          this.$toast.success(this.$t("delete_success"));
          switch (this.tabs) {
            case 0:
              this.defIsLastPage = false;
              this.defPage = 1;
              this.defaultVideos = { data: [] };
              break;
            case 1:
              this.isLastPage = false;
              this.page = 1;
              this.userVideos = { data: [] };
              break;
          }
        })
        .catch(({ response }) => console.log("delete has error: ", response))
        .finally(() => (this.loading = false));
    },
    reloadByUpload() {
      this.userVideos = {
        data: [],
      };
      this.isLastPage = false;
      this.page = 1;
      this.$nextTick(() => {
        this.tabs = 1;
      });
    },
    handleSearch(getDefault = false, reset = false) {
      if (getDefault) {
        if (this.search.defaults.length >= 3) {
          this.defIsLastPage = false;
          this.defaultVideos = { data: [] };
          this.defPage = 1;
          this.$nextTick(() => {
            this.getDefaultVideos(this.search.defaults);
          });
        }
      } else {
        if (this.search.user.length >= 3) {
          this.isLastPage = false;
          this.userVideos = { data: [] };
          this.page = 1;
          this.$nextTick(() => {
            this.getUserVideos(this.search.user);
          });
        }
      }
    },
    clearSearch(defaults = false) {
      if (defaults) {
        this.search.defaults = "";
        this.defIsLastPage = false;
        this.defaultVideos = { data: [] };
        this.defPage = 1;
        this.$nextTick(() => {
          setTimeout(() => {
            this.getDefaultVideos();
          }, 2000);
        });
      } else {
        this.search.user = "";
        this.isLastPage = false;
        this.userVideos = { data: [] };
        this.page = 1;
        this.$nextTick(() => {
          setTimeout(() => {
            this.getUserVideos();
          }, 500);
        });
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 600px) {
  .v-tabs >>> .v-slide-group__prev {
    display: none !important;
  }
}
</style>
